export default (): string => process.env.REACT_APP_API!;



// WEBPACK FOOTER //
// ./src/application/core/api.ts